import { render, staticRenderFns } from "./CaseFileChapterSections.vue?vue&type=template&id=73c5fd66&scoped=true&"
import script from "./CaseFileChapterSections.vue?vue&type=script&lang=js&"
export * from "./CaseFileChapterSections.vue?vue&type=script&lang=js&"
import style0 from "./CaseFileChapterSections.vue?vue&type=style&index=0&id=73c5fd66&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5fd66",
  null
  
)

export default component.exports